import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";

// --- Primary Firebase App Configuration (for Hosting, Auth, Functions) ---
// This will use the main VITE_FIREBASE_ environment variables for qlt-app-uat
const primaryConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// --- Secondary Firebase App Configuration (for Realtime Database only) ---
// UAT routes RTDB writes to a different Firebase project (qlt-app-dev) than the
// hosting/auth project (qlt-app-uat) so test bookings don't pollute prod data.
// `.env.uat` defines VITE_DB_FIREBASE_*; prod (`.env`) falls back to VITE_FIREBASE_*.
// Without this fallback chain, the dbApp would initialize against the primary
// project's RTDB — which for UAT meant test bookings landed in prod RTDB and
// the dispatch team saw them as real bookings.
const dbConfig = {
  apiKey: import.meta.env.VITE_DB_FIREBASE_API_KEY ?? import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_DB_FIREBASE_AUTH_DOMAIN ?? import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_DB_FIREBASE_DATABASE_URL ?? import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_DB_FIREBASE_PROJECT_ID ?? import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_DB_FIREBASE_STORAGE_BUCKET ?? import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_DB_FIREBASE_MESSAGING_SENDER_ID ?? import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_DB_FIREBASE_APP_ID ?? import.meta.env.VITE_FIREBASE_APP_ID
};

// Initialize Firebase Apps
// The primary app for hosting, auth, functions
const primaryApp = !getApps().find((app) => app.name === "[DEFAULT]")
  ? initializeApp(primaryConfig)
  : getApp();

// A secondary, named app specifically for the database connection
const dbApp = !getApps().find((app) => app.name === "dbConnection")
  ? initializeApp(dbConfig, "dbConnection")
  : getApp("dbConnection");

// Get services from the correct app
export const auth = getAuth(primaryApp);
export const functions = getFunctions(primaryApp, "us-central1");
export const db = getDatabase(dbApp);

// Export the primary app if needed elsewhere
export const app = primaryApp;
